import { jsx } from "react/jsx-runtime";
import { Dropdown } from "./Dropdown.js";
function Text({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(Dropdown.Text, {
    fontSize: "list-item",
    ...props,
    children
  });
}
export {
  Text
};
//# sourceMappingURL=Text.js.map
